const PaxSelectorMixin = {
  methods: {
    onPaxClicked () {
      if (!this.paxSelector.dropdown.open) {
        this.openPaxSelector()
      } else {
        this.closePaxSelector()
      }
    },
    closePaxSelector () {
      this.$store.commit('eHorizonSearchForm/paxSelector/hidePaxDropdown')
    },
    openPaxSelector () {
      this.$store.commit('eHorizonSearchForm/paxSelector/showPaxDropdown')
    },
    setAdults (value) {
      if (value <= this.paxSelector.config.maxAdults && value >= this.paxSelector.config.minAdults) {
        if (value < this.paxSelector.adults && this.paxSelector.adults === this.paxSelector.infants) {
          this.$store.commit('eHorizonSearchForm/paxSelector/setInfants', value)
        }

        this.$store.commit('eHorizonSearchForm/paxSelector/setAdults', value)
      }
      this.validateInfantCount()
      this.checkGroupBooking()
    },
    setChildren (value) {
      if (value <= this.paxSelector.config.maxChildren && value >= this.paxSelector.config.minChildren) {
        this.$store.commit('eHorizonSearchForm/paxSelector/setChildren', value)
      }
      this.checkGroupBooking()
    },
    setInfants (value) {
      if (value <= this.paxSelector.adults && (value <= this.paxSelector.config.maxInfants && value >= this.paxSelector.config.minInfants)) {
        this.$store.commit('eHorizonSearchForm/paxSelector/setInfants', value)
      }
      this.validateInfantCount(value)
    },
    setYoungAdults (value) {
      this.$store.commit('eHorizonSearchForm/paxSelector/setYoungAdults', value)
      this.checkGroupBooking()
    },
    checkGroupBooking () {
      const isGroupBooking =
        [this.paxSelector.adults, this.paxSelector.children, this.paxSelector.youngAdults]
          .reduce((sum, value) => sum + value, 0) >= 10
      this.$store.commit('eHorizonSearchForm/paxSelector/setGroupBooking', isGroupBooking)
    },
    validateInfantCount (value) {
      const isCountExceeded = value > this.paxSelector.adults
      this.$store.commit('eHorizonSearchForm/paxSelector/setInfantCountExceeded', isCountExceeded)
    }
  }
}

export default PaxSelectorMixin
